import { render, staticRenderFns } from "./ItemDesignation.vue?vue&type=template&id=79a6f87e"
import script from "./ItemDesignation.vue?vue&type=script&lang=js"
export * from "./ItemDesignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports